import { Box } from "@chakra-ui/react";
import { Typography } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../app/hooks";
import { toggleHelpModal } from "../../../../app/slice/appSlice";
import { APP_PLATFORM, RECONVERT_IO_HELP_URL } from "../../../../config";
import { Platform } from "../../../../models";

const ConditionTitle = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <>
      <Typography variant="h5-medium">
        {t("CONDITION")}
      </Typography>
      <Box my={2}>
        <Typography
          color="link.color"
          variant="body"
          as="a"
          cursor="pointer"
          lineHeight={"20px"}
          className={APP_PLATFORM === Platform.Wix ? "link" : " "}
          onClick={() => {
            const link =
              APP_PLATFORM === Platform.Shopify
                ? `${RECONVERT_IO_HELP_URL}/en/article/how-do-conditions-work-12yqfsv/reader/?bust=1706881668418`
                : `${RECONVERT_IO_HELP_URL}/en/article/how-do-conditions-work-wix-unpozd/`;

            dispatch(
              toggleHelpModal({
                link: link,
                title: t("Conditions settings").toString(),
              }),
            )
          }}
        >
          {t("Learn more about conditions")}
        </Typography>
      </Box>
    </>
  );
};

export default ConditionTitle;
